import React, { useEffect, useRef, useState } from 'react'
import { NavLink, Route, Routes } from 'react-router-dom'
import Dashboard from './Dashboard'
import Products from './Products'
import Profile from './Profile'
import Home from './Home'
import Contact from './Contact'
import Services from './Services'
import logo from './Images/Logo.png'
import menu from './Images/menu.png'
import logo2 from './Images/CartName.png'
import ProductOverview from './ProductOverview'
import EditForm from './EditForm'
import AddNewProducts from './AddNewProducts'
import Brand from './Brand'
import AddBrand from './AddBrand'
import Customersdata from './Customersdata'
import Editbrand from './Editbrand'
import Categorys from './Categorys'
import AddCategorys from './AddCategorys' 
import EditCategorys from './EditCategorys'
import AttributeGroups from './AttributeGroups'
import CreateAttributeGroup from './CreateAttributeGroup'
import EditAttributeGroup from './EditAttributeGroup'
import AttributeTabs from './AttributeTabs'
import CreateAttributeTab from './CreateAttributeTab'
import EditAttributeTab from './EditAttributeTab'
import Order from './Order'
import Customerindividualdata from './Customerindividualdata'
import Productindividualdata from './Productindividualdata'
import Attribute from './Attribute'
import CreateAttribute from './CreateAttribute'
import EditAttribute from './EditAttribute'
import axios from 'axios'
import Vehicle from './Vehicle'
import AddVehicle from './AddVehicle'
import Drivers from './Drivers'
import Adddriver from './Adddriver'
import VehicleOverview from './VehicleOverview'
import { Link } from 'react-router-dom'
import { FaExpandArrowsAlt } from "react-icons/fa";
import { FaCompressArrowsAlt } from "react-icons/fa";
import AddCustomer from './AddCustomer'
import EditCustomer from './EditCustomer'
import Editdriver from './EditDriver'
function Navigation() {

  const componentMap = {
    'Dashboard': Dashboard,
    'Products': Products,
    'Profile': Profile,
    'Brand': Brand,
    'Customersdata': Customersdata,
    'Categorys': Categorys,
    'AttributeGroups': AttributeGroups,
    'AttributeTabs': AttributeTabs,
    'Order': Order,

  }
    //for f11
    const [isToggled, setIsToggled] = useState(true);
    const handleChange = () => {
      setIsToggled(!isToggled);
      if (!document.fullscreenElement) {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) { // Firefox
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
          document.documentElement.webkitRequestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
          document.documentElement.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { // Firefox
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE/Edge
          document.msExitFullscreen();
        }
      }
    };
  const [isOpen, setIsOpen] = useState(false);
  const [navdata, setnavdata] = useState([])
  const[navdatareceived, setnavdatareceived] = useState(false)
  let [footer1, setfooter1] = useState('Copyright © 2024 BOXAIO')
  let [footer2, setfooter2] = useState('Version 1.0 ')
  let [navstatus, setnavstatus] = useState(true)
  let [showLogo, setShowLogo] = useState(true)
  const ref = useRef(null);
  const navigationtoggle = () => {
    setnavstatus(!navstatus)
    ref.current.classList.toggle('closed');
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL+'/api/list').then((response) => {
      setnavdata(response.data)
      setnavdatareceived(true)
    }).catch((error) => {
      console.log(error)
    })
  }, []);

  useEffect(() => {
    if (navstatus) {
      setfooter1('Copyright © 2024 BOXAIO')
      setfooter2('Version 1.1.0 ')
      ref.current.style.width = "298px";
      
    }
    else {
      setfooter1('')
      setfooter2('')
      ref.current.style.width = "48px";

    }
  }, [navstatus,navdatareceived])
  return (
    <>
      
      <div className=' flex'  >
        
        <nav className=' navgationbarforweb w-40 min-h-svh pt-0 flex menunav max-h-full '  ref={ref} >
          {/* style={{ borderRight: '1px solid #600' }} for vertical line place it in above line */}
          <ul className=' w-full shadow-md shadow-lime-600  pt-3 '>
            { <NavLink to="/"  >
              <li className='
               pb-0 pt-1 pl-0 pr-1 mb-3' >
                <div style={{ display: 'flex', alignItems: 'center' }} >
                <img src={logo} alt='no img' className='w-12 ml-1 mt-1 mb-1' />
                {showLogo && <img src={logo2} alt="no img" className='w-15 h-5 mt-0'/>}
                </div>
              </li>
            </NavLink>
            
            }
            {navdata.map((item, index) => {
              return (
                <NavLink to={item.path} key={index}  >
                  <li className='
               pb-2 pt-2 pl-1 pr-2 mb-0 ml-0 mr-0 sidenavbuttons'>
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                      <img src={item.img} alt='no img' className='w-5 ml-2 mt-1 mb-1 mr-4' />
                      {navstatus && <p className='text-sm'>{item.name}</p>}
                    </div>
                  </li>
                </NavLink>
              )
            })}
            
          <footer className='footerforlogo absolute pl-3'>
            <div className='h-12 text-gray-500 text-sm '>
            
              <p className=' '>{footer1}</p>
              <p className='flex  pl-0'>
              <img src={logo} alt='no img' className='w-6 ml-0 mt-1 mb-1 pl-0' /> {footer2}</p>
            </div>
          </footer>
          </ul>
        </nav>
        <main id='main' className=' overflow-y-auto w-full'>
        <div className='topnavdiv  p-2 w-full m-0 shadow-md shadow-lime-100'>
          <div className=' flex justify-between'>
          <div className='flex'>
            <button className='ml-1 flex hover:bg-slate-100/25 menuicon' onClick={() => {
                 navigationtoggle();
                   setShowLogo(!showLogo);
            }} >
              <img src={menu} alt='no img' className='w-5 h-5 m-2 ' />
            </button>
            </div>
            <div className='flex align-middle justify-between mt-2 font-sans'>
            {/* top bar middle contents */}
           
            </div>
            <div className='flex'>
            {/* top bar right contents */}
            <button onClick={handleChange} className={`faarrowalt ${isToggled ? 'on' : 'off'}`}>
                                {isToggled ? <FaExpandArrowsAlt  /> : <FaCompressArrowsAlt />}
                                </button>
          
            <Link href="#" class="notification">
              <i className='fa fa-bell'></i>
              <span className="badge">3</span>
            </Link>

           
      <button type="button" className="  flex text-sm bg-gray-800 rounded-full  focus:ring-1" onClick={()=> { setIsOpen( isOpen ? false : true ); console.log("isopen:"+isOpen) }}>
      
        <img className="w-10 h-10 rounded-full" src="https://assets.weforum.org/sf_account/image/rA_TF_tkRNKjxk_gzlr9UlBXMhuoPZNeRaRO7-ys_xw.jpg" alt='no IMG'></img>
      </button>
      </div>
            </div>
          
        
      </div>
      

      <div className={` z-10 bg-white absolute mr-3 right-0  shadow ${isOpen ? '' : 'hidden'}`}>
        <div className="px-4 py-2 text-sm ">
          {/* <li className="  block text-sm text-gray-600" >Harsha Vardhan</li>
          <li className=" block text-sm  text-gray-600  ">thisisharshavardhan@gmail.com</li> */}
          <ul className=' text-sm text-gray-600 rounded-lg' >
          <li>
            <Link to={"#"} className="block  text-sm text-gray-700 ">Harsha Vardhan</Link>
          </li>
          <li>
            <Link to={"#"} className="block  text-sm text-gray-700 ">
              thisisharshavardhan@gmail.com
            </Link>
          </li>
          </ul>
        </div>
        <ul className="py-2 bg-white  text-sm" >
          <li className="block px-4 py-2 text-sm pl-0  hover:bg-gray-100 ">
            <Link to={"/profile"} className="block px-4 pl-4 text-sm  hover:bg-gray-100 " ><i className='fa fa-user-o text-lg mr-2'></i>Profile</Link>
          </li>
          <li className="block px-4 py-2 text-sm pl-0  hover:bg-gray-100 ">
            <Link to={"/setting"} className="block px-4 pl-4 text-sm  hover:bg-gray-100 "><i className='fa fa-cog text-lg mr-2'></i>Settings</Link>
          </li>
          <li className="block px-4 py-2 text-sm pl-0 hover:bg-gray-100 ">
            <Link to={""} className="block px-4 pl-4 text-sm hover:bg-gray-100 "><i className='fa fa-sign-out text-lg mr-2'></i>Sign out</Link>
          </li>
        </ul>
      </div>
    
          <Routes>
            <Route path="/" element={<Dashboard/>} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/products" element={<Products />} />
            <Route path='/product/:id' element={<Productindividualdata/>} />
            <Route path="/profile" element={<Profile />} />
            <Route path='/Home' element={<Home />} />
            <Route path='/Contact' element={<Contact />} />
            <Route path='/Services' element={<Services />} />
            <Route path='/Products/ProductOverview' element={<ProductOverview/>}/>
            <Route path='/Products/addNewProducts' element={<AddNewProducts />} />
            <Route path='/products/EditForm/:id' element={<EditForm />} />  
            <Route path='/brand' element={<Brand/>} />
            <Route path='/customers' element={<Customersdata/>} />
            <Route path='/customer/:id' element={<Customerindividualdata/>} />
            <Route path='/categories' element={<Categorys/>} />
            <Route path='/brand/addBrand' element={<AddBrand/>} />
            <Route path='/brand/editbrand/:id' element={<Editbrand />} />
            <Route path='/categories/addcategory' element={<AddCategorys />} />
            <Route path='/categories/editcategory/:id' element={<EditCategorys />} />
            <Route path='/AttributeGroups' element={<AttributeGroups />} />
            <Route path='/AttributeGroups/CreateAttributeGroup' element={<CreateAttributeGroup />} />
            <Route path='/AttributeGroups/EditAttributeGroup/:id' element={<EditAttributeGroup />} />
            <Route path='/AttributeTabs' element={<AttributeTabs />} />
            <Route path='/AttributeTabs/CreateAttributeTab' element={<CreateAttributeTab />} />
            <Route path='/AttributeTabs/EditAttributeTab/:id' element={<EditAttributeTab />} />
            <Route path='/orders' element={<Order />} />
            <Route path='/Attributes' element={<Attribute />} />
            <Route path='/Attribute/CreateAttribute' element={<CreateAttribute />} />
            <Route path='/Attribute/EditAttribute/:id' element={<EditAttribute />} />
            <Route path='/customers/addcustomer' element={<AddCustomer/>}/>
            <Route path='/editcustomer/:id' element={<EditCustomer/>}/>

            {/* Vehicle routes */}
            <Route path='/vehicles' element={<Vehicle/>} />
            <Route path='/vehicles/addvehicle' element={<AddVehicle />} />
            <Route path='*' element={<div>No such Path found.</div>} /> 
            <Route path='/drivers' element={<Drivers />} />
            <Route path='/drivers/adddriver' element={<Adddriver />} />
            <Route path='/vehicles/VehicleOverview' element={<VehicleOverview />} />
            <Route path='/drivers/editdriver/:id' element={<Editdriver />} />
            {
              navdata.map((item, index) => {
                const Component = componentMap[item.component];
                  return Component ? <Route path={item.path} element={<Component />} /> : null;
              })
            }
          </Routes>
        </main>
      </div>
    </>
  )
}

export default Navigation